if (!customElements.get('fm-review-carousel')) {
  customElements.define('fm-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.fm-review-track');
      this.cards = [...this.querySelectorAll('.fm-review-card')];
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.controls = this.querySelector('.fm-review-controls');
      this.count = this.querySelector('.fm-review-count');
      if (!this.track) return;
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.update(), 100);
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.cards.length - 1);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.fm-review-card');
        if (card) this.go(this.cards.indexOf(card), 'auto');
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.reviewDialog = document.createElement('dialog');
      this.reviewDialog.className = 'fm-review-dialog';
      this.reviewDialog.setAttribute('aria-label', 'Ολόκληρη κριτική πελάτη');
      const closeReview = document.createElement('button');
      closeReview.type = 'button';
      closeReview.className = 'fm-review-dialog-close';
      closeReview.textContent = 'Κλείσιμο';
      this.reviewDialog.append(closeReview);
      this.append(this.reviewDialog);
      closeReview.addEventListener('click', () => this.reviewDialog.close(), options);
      this.reviewDialog.addEventListener('close', () => {
        this.reviewOpener?.setAttribute('aria-expanded', 'false');
        this.reviewOpener?.focus();
      }, options);
      this.classList.add('is-ready');
      this.cards.forEach(card => {
        const photo = card.querySelector('[data-review-photo]');
        photo?.addEventListener('click', () => {
          this.reviewOpener = photo;
          this.reviewDialog.querySelectorAll('blockquote, figcaption, .fm-review-dialog-image').forEach(x => x.remove());
          this.reviewDialog.classList.add('fm-review-dialog--photo');
          this.reviewDialog.setAttribute('aria-label', 'Φωτογραφία πελάτη σε μεγέθυνση');
          const image = document.createElement('img');
          image.className = 'fm-review-dialog-image';
          image.alt = photo.querySelector('img')?.alt || 'Φωτογραφία πελάτη';
          image.src = photo.dataset.fullImage || photo.querySelector('img').src;
          this.reviewDialog.append(image);
          this.reviewDialog.showModal();
          this.reviewDialog.querySelector('button').focus();
        }, options);
        const quote = card.querySelector('blockquote');
        const button = card.querySelector('.fm-review-more');
        if (!button) return;
        button.removeAttribute('aria-controls');
        button.setAttribute('aria-haspopup', 'dialog');
        button.addEventListener('click', () => {
          this.reviewOpener = button;
          this.reviewDialog.querySelector('.fm-review-dialog-image')?.remove();
          this.reviewDialog.classList.remove('fm-review-dialog--photo');
          this.reviewDialog.setAttribute('aria-label', 'Ολόκληρη κριτική πελάτη');
          this.reviewDialog.querySelector('blockquote')?.remove();
          this.reviewDialog.querySelector('figcaption')?.remove();
          const copy = quote.cloneNode(true);
          copy.removeAttribute('id');
          copy.classList.add('is-expanded');
          this.reviewDialog.append(copy, card.querySelector('figcaption').cloneNode(true));
          this.reviewDialog.showModal();
          button.setAttribute('aria-expanded', 'true');
          this.reviewDialog.querySelector('button').focus();
        }, options);
      });
      this.update();
    }
    positions() {
      const left = this.track.getBoundingClientRect().left;
      return this.cards.map(card => card.getBoundingClientRect().left - left + this.track.scrollLeft - 2);
    }
    update() {
      this.cards.forEach(card => {
        const quote = card.querySelector('blockquote');
        const button = card.querySelector('.fm-review-more');
        if (button) button.hidden = !quote.classList.contains('is-expanded') && quote.scrollHeight <= quote.clientHeight + 2;
      });
      const max = this.track.scrollWidth - this.track.clientWidth;
      const pos = this.track.scrollLeft;
      this.controls.hidden = max < 4 || this.cards.length < 2;
      this.prev.disabled = pos < 4;
      this.next.disabled = pos >= max - 4;
      const rect = this.track.getBoundingClientRect();
      const visible = this.cards.map((card,i) => ({r:card.getBoundingClientRect(),i})).filter(({r}) => Math.min(r.right, rect.right) - Math.max(r.left, rect.left) > r.width * 0.5);
      if (visible.length) {
        const first = visible[0].i + 1, last = visible[visible.length - 1].i + 1;
        this.count.textContent = `${first === last ? first : first + '–' + last} / ${this.cards.length}`;
      }
    }
    move(direction) {
      const pos = this.track.scrollLeft;
      const positions = this.positions();
      const target = direction > 0 ? positions.findIndex(p => p > pos + 5) : positions.findLastIndex(p => p < pos - 5);
      this.go(target < 0 ? (direction > 0 ? this.cards.length - 1 : 0) : target);
    }
    go(index, behavior) {
      const left = this.positions()[index];
      if (left === undefined) return;
      this.track.scrollTo({ left, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
    }
    disconnectedCallback() {
      this.reviewDialog?.close();
      this.reviewDialog?.remove();
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.timer);
    }
  });
}